export default "__VITE_ASSET__DPqket5x__"